module.exports = __webpack_public_path__ + "static/media/gd.ba2b01cb.webp";